module.exports = __webpack_public_path__ + "static/media/GEMBOK_LOCK_TANPABINTANG.02191785.png";